import { Controller } from "@hotwired/stimulus"

// リールのカバーを「動画から選ぶ(thumb_offset)」「画像をアップロード(cover_url)」から選ぶ。
// 動画ファイルは scheduled-post コントローラーが持つため、選択・解除は scheduled-post:video-selected / video-cleared イベントで受け取る
export function formatOffset(ms) {
  const value = Number.isFinite(ms) && ms > 0 ? ms : 0
  const totalTenths = Math.floor(value / 100)
  const minutes = Math.floor(totalTenths / 600)
  const seconds = Math.floor((totalTenths % 600) / 10)
  const tenths = totalTenths % 10
  return `${minutes}:${String(seconds).padStart(2, "0")}.${tenths}`
}

export function clampOffset(ms, durationSec) {
  const rounded = Math.round(Number(ms) || 0)
  const lower = Math.max(0, rounded)
  if (!Number.isFinite(durationSec)) return lower
  return Math.min(lower, Math.round(durationSec * 1000))
}

export default class extends Controller {
  static targets = ["frameSection", "imageSection", "emptyNote", "picker", "video", "range", "label", "offsetInput"]
  static values = { videoUrl: String }

  connect() {
    this.objectUrl = null
    this.toggleSource()
    if (this.videoUrlValue) this.showVideo(this.videoUrlValue)
  }

  disconnect() {
    this.revokeObjectUrl()
  }

  // ラジオ(cover_source)の切替
  toggleSource() {
    const source = this.element.querySelector('input[name="instagram_scheduled_post[cover_source]"]:checked')?.value || "frame"
    this.frameSectionTarget.classList.toggle("hidden", source !== "frame")
    this.imageSectionTarget.classList.toggle("hidden", source !== "image")
  }

  // scheduled-post:video-selected
  load(event) {
    const file = event.detail?.file
    if (!file) return
    this.revokeObjectUrl()
    this.objectUrl = URL.createObjectURL(file)
    // 動画を選び直したら位置は先頭に戻す
    this.offsetInputTarget.value = "0"
    this.showVideo(this.objectUrl)
  }

  // scheduled-post:video-cleared
  clear() {
    this.revokeObjectUrl()
    this.videoTarget.removeAttribute("src")
    this.videoTarget.load?.()
    this.offsetInputTarget.value = ""
    this.pickerTarget.classList.add("hidden")
    this.emptyNoteTarget.classList.remove("hidden")
  }

  showVideo(src) {
    this.videoTarget.src = src
    this.pickerTarget.classList.remove("hidden")
    this.emptyNoteTarget.classList.add("hidden")
  }

  // video の loadedmetadata
  metadataLoaded() {
    const duration = this.videoTarget.duration
    this.rangeTarget.max = String(Math.floor(duration * 1000))
    const offset = clampOffset(Number(this.offsetInputTarget.value || 0), duration)
    this.applyOffset(offset)
  }

  // range の input
  scrub() {
    this.applyOffset(clampOffset(Number(this.rangeTarget.value), this.videoTarget.duration))
  }

  applyOffset(offset) {
    this.rangeTarget.value = String(offset)
    this.offsetInputTarget.value = String(offset)
    this.labelTarget.textContent = formatOffset(offset)
    if (Number.isFinite(this.videoTarget.duration)) this.videoTarget.currentTime = offset / 1000
  }

  revokeObjectUrl() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
